import React, {useEffect, useState} from 'react';
import '../ChestPurchaseModal/ChestPurchaseModal.css';
import '../PremiumInfoModal/PremiumInfoModal.css';
import './CrystalsInfoModal.css';
import PageButton from '../../elements/PageButton/PageButton';
import PurchaseInterestRewardModal from '../PurchaseInterestRewardModal/PurchaseInterestRewardModal';
import {getCrystalsImagePath} from '../../../utils/crystals/getCrystalsImagePath';
import {getFormattedPrice} from '../../../utils/price/getFormattedPrice';
import {PURCHASE_INTEREST_TYPES} from '../../../configs/purchaseInterestRewards';
import {MINUS_SIGN, RUBLE_SIGN} from '../../../constants/text';
import {MENU_SOUND_MANAGER} from '../../../scenes/MenuSoundManager';
import {RUBY_COLOR} from '../../../styles/constants';

const PAGE_ID = 'CrystalsInfoModal';

/**
 * Модалка набора кристаллов в магазине: тот же стиль, что у модалки премиума
 * (общие классы chest-purchase-* и premium-info-*), но рассказывает, что на
 * кристаллы можно купить. Покупка пока не подключена — кнопка покупки
 * открывает модалку раннего доступа с разовым подарком
 */
function CrystalsInfoModal({crystalsConfig, onClose}) {
  const [visible, setVisible] = useState(false);
  const [showInterestModal, setShowInterestModal] = useState(false);

  // Звук — тот же, что у модалки кристаллов за рейтинг (строительство рудника
   // гномами). Играет только когда модалка действительно показывается: ниже
   // без конфига набора идет return null
  const hasConfig = Boolean(crystalsConfig);
  useEffect(() => {
    if (!hasConfig) return undefined;
    MENU_SOUND_MANAGER.playMineExploration();
    const showTimer = setTimeout(() => setVisible(true), 50);
    return () => clearTimeout(showTimer);
  }, [hasConfig]);

  const handleClose = () => {
    setVisible(false);
    setTimeout(() => onClose?.(), 300);
  };

  const handleOverlayClick = (event) => {
    if (event.target === event.currentTarget) {
      handleClose();
    }
  };

  if (!crystalsConfig) return null;

  return (
    <div
      className={`chest-purchase-overlay ${visible ? 'chest-purchase-overlay_visible' : ''}`}
      onClick={handleOverlayClick}
      role={'dialog'}
      aria-modal={'true'}
      style={{'--chest-shadow-color': RUBY_COLOR, '--crystals-modal-glow-color': RUBY_COLOR}}
    >
      <div className={`chest-purchase-modal crystals-info-modal ${visible ? 'chest-purchase-modal_visible' : ''}`}>
        <div className={'chest-purchase-content'}>
          <div className={'chest-purchase-image-wrapper'}>
            <img
              className={'chest-purchase-image'}
              src={getCrystalsImagePath(crystalsConfig.id)}
              alt={`${crystalsConfig.crystals} кристаллов`}
            />
          </div>

          <h2 className={'chest-purchase-name text-crystals crystals-info-title'}>
            {getFormattedPrice(crystalsConfig.crystals)}
            <img className={'crystals-info-title-icon'} src={'/img/icons/crystal.png'} alt={'Кристаллы'}/>
          </h2>

          <p className={'crystals-info-lead'}>
            Кристаллы — премиальная валюта Стратегикона. Тратятся на то, что не купить за нумены:
          </p>

          <div className={'premium-info-benefits'}>
            <div className={'premium-info-benefit'}>
              <span
                className={'premium-info-benefit-icon crystals-info-benefit-icon_factions'}
                role={'img'}
                aria-label={'Фракции'}
              />
              <span>
                <span className={'premium-info-benefit-accent text-crystals'}>Фракции</span>
                <span className={'premium-info-benefit-regular'}>— каждая со своим бонусом и стилем игры</span>
              </span>
            </div>
            <div className={'premium-info-benefit'}>
              <span
                className={'premium-info-benefit-icon premium-info-benefit-icon_chest'}
                role={'img'}
                aria-label={'Сундуки'}
              />
              <span>
                <span className={'premium-info-benefit-accent'}>Сундуки</span>
                <span className={'premium-info-benefit-regular'}>— обличия фракций и образы отрядов</span>
              </span>
            </div>
            <div className={'premium-info-benefit'}>
              <img className={'premium-info-benefit-icon'} src={'/img/icons/premium.png'} alt={'Премиум'}/>
              <span>
                <span className={'premium-info-benefit-accent'}>Дни Премиума</span>
              </span>
            </div>
            <div className={'premium-info-benefit'}>
              <img className={'premium-info-benefit-icon'} src={'/img/icons/numens.png'} alt={'Нумены'}/>
              <span>
                <span className={'premium-info-benefit-regular'}>
                  Обмен на <span className={'premium-info-benefit-accent'}>нумены</span>
                </span>
              </span>
            </div>
            {crystalsConfig.discountPercents > 0 && (
              <div className={'premium-info-benefit'}>
                <img className={'premium-info-benefit-icon'} src={'/img/icons/coupon.png'} alt={'Скидка'}/>
                <span>
                  <span className={'premium-info-benefit-accent'}>
                    Выгода {crystalsConfig.discountPercents}%
                  </span>
                  <span className={'premium-info-benefit-regular'}>по сравнению с меньшими наборами</span>
                </span>
              </div>
            )}
          </div>

          <div className={'main-menu-buttons chest-purchase-buttons'}>
            <PageButton
              className={'chest-purchase-buy-button'}
              onClick={() => setShowInterestModal(true)}
              pageId={PAGE_ID}
              buttonId={`buy_${crystalsConfig.id}`}
            >
              <span className={'crystals-info-price'}>
                Купить за {getFormattedPrice(crystalsConfig.priceRub)} {RUBLE_SIGN}
              </span>
              {crystalsConfig.discountPercents > 0 && (
                <span className={'crystals-info-discount-badge'}>
                  {MINUS_SIGN}{crystalsConfig.discountPercents}%
                </span>
              )}
            </PageButton>

            <PageButton
              className={'main-menu-button_secondary'}
              onClick={handleClose}
              pageId={PAGE_ID}
              buttonId={'hide'}
            >
              Скрыть
            </PageButton>
          </div>
        </div>
      </div>

      {showInterestModal && (
        <PurchaseInterestRewardModal
          type={PURCHASE_INTEREST_TYPES.CRYSTALS}
          onClose={() => setShowInterestModal(false)}
        />
      )}
    </div>
  );
}

export default CrystalsInfoModal;
